var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "primary",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 37.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-450 -260)"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    d: "M469.911,267.813l0.732,0.683l2.832-3.047c-0.087,5.094-0.871,9.124-2.483,12.209   c0.001-0.053,0.008-0.104,0.008-0.158c0-3.032-2.468-5.5-5.5-5.5s-5.5,2.468-5.5,5.5s2.468,5.5,5.5,5.5   c0.193,0,0.384-0.011,0.571-0.03c-3.372,2.077-7.979,3.03-14.071,3.03v1c15.672,0,22.228-6.292,22.477-21.605l2.881,3.101   l0.732-0.683l-4.089-4.397L469.911,267.813z M461,277.5c0-2.481,2.019-4.5,4.5-4.5s4.5,2.019,4.5,4.5s-2.019,4.5-4.5,4.5   S461,279.981,461,277.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.31d77c789b2a54249144f19bb71c5999.svg";
export { ForwardRef as ReactComponent };